import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {  FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { getAccountingRelationAssetsAccounts } from "../../../../../../store/actions/precog";
import VaporDrawer from "../../../../../general/vapor/drawer";
import "./style.scss";

const DrawerAccountsDetail = ({accountCode, isDrawerOpen, setIsDrawerOpen, title}) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [dataSetAccounts, setDataSetAccounts] = useState([]);  

  useEffect(() => {
    if (!accountCode) return undefined;
    dispatch(getAccountingRelationAssetsAccounts(accountCode)).then(res => {              
      setDataSetAccounts(res);
    }).catch(err => {
      console.log(err);
    });
    return undefined;
  }, [accountCode]);
    
  return (
    <VaporDrawer
      customClassName="drawerAccountsDetail"
      visible={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      title={`${intl.formatMessage({id: "preCog.assetsTab.drawer.accountAssetsDetail.drawerTitle"})}`}
      content={<div></div>}      
      width={"800px"}      
      maskClosable={false}        
      hideFooter={true}
      closeOnRight={true}      
    >
      <div style={{padding: "32px"}}>
        <div data-testid="breadcrumbAsset" className="breadcrumb" onClick={() => setIsDrawerOpen(false)}>
          <FontAwesomeIcon 
            icon={["fas", "angle-left"]} 
            style={{fontSize: "16px", marginRight: "8px", verticalAlign: "-3px"}} />
          {title}
        </div>
        {dataSetAccounts?.map((el, index) => {
          return <div data-testid="singleAccountDetailItem" 
            className="singleAccountDetailItem" key={`singleAccountDetailItem_${index}`}>
            <div className="customNameTranslated"><FormattedMessage id={`preCog.assetsTab.drawer.accountAssetsDetail.names.${el.name}`} /></div>
            <div className="itemAccountidAndDesc">{el.code} - {el.description}</div>
          </div>;
        })}
      </div>
    </VaporDrawer>
  );
};

export default DrawerAccountsDetail;